import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'xui-module-disabled',
    templateUrl: './module-disabled.component.html',
    styleUrls: ['./module-disabled.component.scss'],
})
export class ModuleDisabledComponent implements OnInit {

  ngOnInit(): void {
  }

}
